import { FC } from 'react';
import { AuthUser, getUserDetails } from '../../lib/services/auth.service';
import { Avatar } from '@mui/material';
import Icon from '../icon';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';

interface Props {
  user: AuthUser;
  withTooltip?: boolean;
  size?: 'small' | 'medium';
}

const useStyles = createUseStyles({
  userBadge: {
    '&.no-photo': {
      backgroundColor: '#7ebd94',
    },
    '&.small': {
      width: 24,
      height: 24,
      fontSize: '0.75rem',
    },
  },
});

const UserBadge: FC<Props> = ({ user, size = 'medium' }) => {
  const styles = useStyles();

  const { hasPhoto, hasName, first, last, username, photoURL } = getUserDetails(user);
  const initials = `${first[0] || ''}${last[0] || ''}`.toUpperCase();
  const compClass = classNames(styles.userBadge, size, { 'no-photo': !hasPhoto });

  return (
    <span>
      {hasPhoto && (
        <Avatar
          alt={username}
          src={photoURL || ''}
          imgProps={{ referrerPolicy: 'no-referrer' }}
          className={compClass}
        />
      )}
      {!hasPhoto && hasName && <Avatar className={compClass}>{initials}</Avatar>}
      {!hasPhoto && !hasName && (
        <Avatar className={compClass}>
          <Icon name="person" color="white" />
        </Avatar>
      )}
    </span>
  );
};

export default UserBadge;
